import { useEffect, useState } from 'react';

import { IEventEnrollment } from '../../store/admin/eventEnrollments/store';
import { IEventDetailedRound } from '../../store/admin/eventRounds/store';

interface IUsePlayersInTeeSheet {
  enrollments: IEventEnrollment[];
  round: IEventDetailedRound | undefined;
}

export const usePlayersInTeeSheet = (args: IUsePlayersInTeeSheet) => {
  const { enrollments, round } = args;

  const [roundGroupsEnrollments, setRoundGroupsEnrollments] = useState<number[]>([]);
  const [eventRegisteredPlayers, setEventRegisteredPlayers] = useState<IEventEnrollment[]>([]);

  useEffect(() => {
    if (round) {
      const groupsEnrollments = (round.groups || []).flatMap(group =>
        (group.games || []).flatMap(game => game.enrollment)
      );

      setRoundGroupsEnrollments(groupsEnrollments);
    }
  }, [round]);

  useEffect(() => {
    setEventRegisteredPlayers(
      enrollments.filter(enrollment => roundGroupsEnrollments.includes(enrollment.id))
    );
  }, [enrollments, roundGroupsEnrollments]);

  return [eventRegisteredPlayers];
};
